<template>
  <div
    class="mx-auto grid w-full grid-cols-2 gap-10 px-10 pb-10 align-top md:grid-cols-4 lg:grid-cols-5 max-w-[1200px]">

    <ul
      v-for="{ name, links } in publicMenus"
      :key="`footer-nav-${name}`"
      class="flex flex-col gap-2">
      <li class="text-blue-4b button-1">{{ name }}</li>
      <li>
        <ul class="flex flex-col gap-1">
          <li v-for="{ label, link, target, id } in links" :key="`ftr-link-${label}`">
            <a
              v-if="target === '_blank'"
              :id="id"
              :href="link"
              class="text-blue-2 text-f1 hover:text-blue-4"
              target="_blank">
              {{ label }}
            </a>
            <RouterLink
              v-else
              :id="id"
              :target="target ?? '_self'"
              :to="link"
              class="text-blue-2 text-f1 hover:text-blue-4">
              {{ label }}
            </RouterLink>
          </li>
        </ul>
      </li>
    </ul>
    <SocialIcons class="md:col-span-4 lg:col-span-1" />
  </div>
</template>

<script lang="ts" setup>
import SocialIcons from '@/components/Footer/SocialIcons.vue'
import { useMenus } from '@/composables/useMenus.ts'
import { useSessionStore } from '@/store/pinia/SessionStore.ts'
import { computed } from 'vue'
import OtivoLogo from '@/components/SVGS/BrandIcons/OtivoLogo.svg'
import { useAdviserPages } from '@/composables/useAdviserPages.ts'

const sessionStore = useSessionStore()

const publicMenus = computed(() =>
  sessionStore.getWhitelabelData.identifier === 'COLONIAL_FIRST_STATE'
    ? useMenus().cfsD2dMenus
    : useMenus().publicMenus,
)
</script>

<style scoped></style>
